/** Ordered from most to least privileged; the single source for validation and pickers. */
export const WORKSPACE_ROLES = ['owner', 'member', 'observer'];
/** Which profile a workspace fills in: stage and TRL for a startup, revenue and sites for a company. */
export const WORKSPACE_KINDS = ['startup', 'company'];
/** Revenue bands (a range, not a figure: companies rarely give the exact one). */
export const REVENUE_RANGES = ['lt_2m', '2_10m', '10_50m', '50_250m', 'gt_250m'];
/** Business functions an assessment can involve; stored as a comma-separated list of these codes. */
export const COMPANY_FUNCTIONS = [
    'management',
    'finance',
    'hr',
    'it',
    'operations',
    'sales',
    'marketing',
    'legal',
    'rnd',
    'other',
];
/** Upper bound of `sites_count`, shared so the form and the server agree. */
export const MAX_SITES = 10000;
/** Profile columns that belong to one kind only; the rest are shared. */
export const STARTUP_ONLY_FIELDS = ['stage', 'project_stage', 'trl'];
export const COMPANY_ONLY_FIELDS = ['revenue_range', 'sites_count', 'functions_involved'];
export function parseFunctions(value) {
    return value ? value.split(',').filter(Boolean) : [];
}
/**
 * The workspace columns that make up the company profile, in form order.
 * Backend validation, the edit form and the shared type all derive from this
 * list, so adding a column means touching the migration and this array only.
 */
export const COMPANY_PROFILE_FIELDS = [
    'industry',
    'sector',
    'kind',
    'stage',
    'country',
    'employees_range',
    'website',
    'technology',
    'project_stage',
    'target_market',
    'geographic_market',
    'revenue_range',
    'functions_involved',
];
/** Profile columns that are stored as numbers rather than text. */
export const COMPANY_PROFILE_NUMERIC_FIELDS = ['founding_year', 'trl', 'sites_count'];
